/**
 * Siloed hoodie API wrappers for classic_site parity reads.
 * Re-exports root hoodieApi where appropriate; add silo-specific docs here.
 *
 * Auth: GET = anonymous (credentials omit). Mutations not exposed until verified.
 */

import {
  getListings,
  getListingById,
  getEvents,
  getPromos,
  getTags,
  getTagGroupings,
  getSocialGroups,
  getMyProfile,
  isHoodieApiConfigured,
  patchListingById,
} from "../../../api/services/hoodieApi";
import { HOODIE_API_BASE_URL } from "../../../api/config";

/** @see GET /api/hoodie/listings/ — verified Tier 1 */
export async function getPublicListings(params = {}) {
  return getListings(params);
}

/** @see GET /api/hoodie/listings/{id}/ — verified Tier 1 */
export async function getPublicListingById(id) {
  return getListingById(id);
}

/** @see GET /api/hoodie/events/ — verified Tier 1 (active, future, enabled entries) */
export async function getPublicEvents(params = {}) {
  return getEvents(params);
}

/** @see GET /api/hoodie/promos/ — verified Tier 1 */
export async function getPublicPromos() {
  return getPromos();
}

/** @see GET /api/hoodie/tags/ */
export { getTags, getTagGroupings, getSocialGroups };

/** @deprecated for session checks — use auth/fetchSessionProfile (credentials:include). */
export { getMyProfile };

/** Blocked for member silo until staging verification — re-export for admin-tools parity only */
export { patchListingById };

export { isHoodieApiConfigured, HOODIE_API_BASE_URL };
